/* ==========================================================================
   Yurls Shop — megamenu op desktop

   Opent een paneel bij aanwijzen met de muis, en bij klikken of Enter.

   Aanwijzen heeft een kleine vertraging bij openen (120 ms), zodat het niet
   flitst als je er alleen langs beweegt, en een wat langere bij sluiten
   (250 ms), zodat je de muis schuin naar het paneel kunt bewegen zonder dat
   het dichtklapt. Staat er al een paneel open, dan wisselt het direct.

   Klikken met de muis opent alleen — het paneel is dan meestal al open door
   het aanwijzen, en een klik die het weer dichtdoet voelt als een fout.
   Met toetsenbord of vinger wisselt een klik tussen open en dicht.

   Sluiten: Escape (focus terug naar de knop), klikken buiten het menu, of
   met de tab-toets het menu uit gaan.
   ========================================================================== */

class YurlsMegaMenu extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-mega-item]'));
    this.openItem = null;
    this.timer = null;

    this.items.forEach((item) => {
      const trigger = item.querySelector('[data-mega-trigger]');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const mouse = event.pointerType === 'mouse';
        if (this.openItem === item && !mouse) {
          this.close();
        } else {
          this.open(item);
        }
      });

      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.schedule(() => this.open(item), this.openItem ? 0 : 120);
      });

      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.schedule(() => this.close(), 250);
      });
    });

    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.openItem) return;
      const trigger = this.openItem.querySelector('[data-mega-trigger]');
      this.close();
      trigger.focus();
    });

    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.close();
    });

    this.onDocumentClick = (event) => {
      if (this.openItem && !this.contains(event.target)) this.close();
    };
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  schedule(fn, delay) {
    clearTimeout(this.timer);
    this.timer = setTimeout(fn, delay);
  }

  open(item) {
    clearTimeout(this.timer);
    if (this.openItem && this.openItem !== item) this.setState(this.openItem, false);
    this.setState(item, true);
    this.openItem = item;
  }

  close() {
    clearTimeout(this.timer);
    if (this.openItem) this.setState(this.openItem, false);
    this.openItem = null;
  }

  setState(item, open) {
    item.classList.toggle('is-open', open);
    item.querySelector('[data-mega-trigger]').setAttribute('aria-expanded', open ? 'true' : 'false');
  }
}

if (!customElements.get('yurls-mega-menu')) {
  customElements.define('yurls-mega-menu', YurlsMegaMenu);
}
